import { CURRICULUM_KEYS } from '@mathflat/domain/Curriculum'

import { curriculumCoreService } from '@/service/curriculumCore.service'

// 교과서의 경우 특정 학년에서 curriculumKey를 그대로 내려보내면 안되기에 mapping하는 로직.
// 특정 학년의 교과서는 2학기를 더 이상 지원하지 않기 때문(1개의 교과서를 1년동안 사용).
export const getCurriculumKeyForSchool = (curriculumKey: string): string => {
  const curriculumInfo = curriculumCoreService.getItemByTrieKey(curriculumKey)
  if (!curriculumInfo) return curriculumKey

  const { schoolType, trieKey } = curriculumInfo

  // 중학교 교과서는 학기 구분이 없어 학기 curriculumKey가 아닌 학년 curriculumKey를 보낸다.
  if (schoolType === 'MIDDLE') {
    return curriculumInfo.upperTrieKey
  }

  // 고등수학(하)는 고등수학(상)의 curriculumKey를 보낸다.
  if (schoolType === 'HIGH' && trieKey === CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학_하) {
    return CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학_상
  }

  return curriculumKey
}
